/* Vzuto carousels V2 — arrows + pager dots + "is-primary" next + when-pill.
   Idempotent. Designed to survive Pace's async hydration of
   .product-recommendations (recommendedProducts event) and
   .recently-viewed-products (recentlyViewedProducts event). */
(function () {
  'use strict';

  var syncByBlock = new WeakMap();

  function wireArrows(root) {
    var ul = root.querySelector('ul.vz-row');
    var prev = root.querySelector('[data-vz-prev]');
    var next = root.querySelector('[data-vz-next]');
    var dotsHost = root.querySelector('[data-vz-dots]');
    if (!ul || !prev || !next) return null;

    if (root.dataset.vzWired === '1') {
      var existing = syncByBlock.get(root);
      if (existing) existing();
      return existing;
    }
    root.dataset.vzWired = '1';

    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function stepBy() {
      var first = ul.querySelector(':scope > li');
      if (!first) return 0;
      var cs = getComputedStyle(ul);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function pageCount() {
      if (ul.clientWidth <= 0) return 0;
      return Math.max(1, Math.ceil(ul.scrollWidth / ul.clientWidth));
    }

    function buildDots() {
      if (!dotsHost) return;
      var count = pageCount();
      // Hide dots when only 1 page (nothing to paginate).
      if (count <= 1) {
        dotsHost.innerHTML = '';
        return;
      }
      // Only rebuild if count changed.
      if (dotsHost.children.length === count) return;
      dotsHost.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vz-dot';
        btn.setAttribute('aria-label', 'Сторінка ' + (i + 1));
        btn.dataset.vzDotIndex = String(i);
        btn.addEventListener('click', function (e) {
          var idx = parseInt(e.currentTarget.dataset.vzDotIndex, 10);
          ul.scrollTo({
            left: idx * ul.clientWidth,
            behavior: reduce ? 'auto' : 'smooth'
          });
        });
        dotsHost.appendChild(btn);
      }
    }

    function sync() {
      var max = ul.scrollWidth - ul.clientWidth - 1;
      var atStart = ul.scrollLeft <= 0;
      var atEnd = ul.scrollLeft >= max;
      var scrollable = max > 0;

      prev.toggleAttribute('disabled', atStart || !scrollable);
      next.toggleAttribute('disabled', atEnd || !scrollable);

      // Filled-black "primary" state on next arrow:
      // applied only when at scroll start AND row is scrollable.
      // Disabled state already overrides via CSS (.is-primary:not([disabled])).
      // Filled-black "primary" state on the next arrow applies ONLY to the
      // recommendations block. Recently-viewed keeps both arrows outlined (per mockup).
      var isRecent = root.classList.contains('recently-viewed-products');
      next.classList.toggle('is-primary', !isRecent && atStart && scrollable);
      prev.classList.remove('is-primary');

      // Active dot syncs to current page.
      if (dotsHost && dotsHost.children.length > 0) {
        var active = Math.round(ul.scrollLeft / ul.clientWidth);
        if (active < 0) active = 0;
        if (active >= dotsHost.children.length) active = dotsHost.children.length - 1;
        Array.from(dotsHost.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
      }
    }

    prev.addEventListener('click', function () {
      ul.scrollBy({ left: -stepBy(), behavior: reduce ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', function () {
      ul.scrollBy({ left: stepBy(), behavior: reduce ? 'auto' : 'smooth' });
    });
    ul.addEventListener('scroll', sync, { passive: true });

    new ResizeObserver(function () {
      buildDots();
      sync();
    }).observe(ul);

    var doSync = function () {
      buildDots();
      sync();
    };
    syncByBlock.set(root, doSync);
    doSync();
    return doSync;
  }

  // ─── "When" tracking ────────────────────────────────────────────
  var WHEN_KEY = 'vz_recent_when';

  function readWhen() {
    try { return JSON.parse(localStorage.getItem(WHEN_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeWhen(map) {
    try { localStorage.setItem(WHEN_KEY, JSON.stringify(map)); } catch (e) {}
  }
  function markCurrent() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = canonical ? canonical.getAttribute('href') : location.href;
    var m = path && path.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var map = readWhen();
    map[handle] = Date.now();
    var entries = Object.entries(map).sort(function (a, b) {
      return b[1] - a[1];
    }).slice(0, 30);
    writeWhen(Object.fromEntries(entries));
  }

  function formatWhen(t) {
    if (!t) return '';
    var diff = Date.now() - t;
    var DAY = 86400000;
    if (diff < DAY) return 'Сьогодні';
    if (diff < 2 * DAY) return 'Вчора';
    var days = Math.floor(diff / DAY);
    if (days < 5) return days + ' дн. тому';
    if (days < 14) return 'тиждень тому';
    if (days < 21) return '2 тиж. тому';
    if (days < 28) return '3 тиж. тому';
    if (days <= 31) return 'місяць тому';
    return '';
  }

  function injectPills(root) {
    if (!root) return;
    var map = readWhen();
    root.querySelectorAll('.vz-card--recent:not([data-vz-when-done])').forEach(function (card) {
      card.setAttribute('data-vz-when-done', '1');
      var handle = card.getAttribute('data-product-handle');
      if (!handle) {
        // Fallback: parse from any product link inside the card.
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        handle = m[1];
      }
      var label = formatWhen(map[handle]);
      if (!label) return;
      var fig = card.querySelector('.vz-card-image');
      if (!fig || fig.querySelector('.vz-recent-when')) return;
      var span = document.createElement('span');
      span.className = 'vz-recent-when';
      span.textContent = label;
      fig.appendChild(span);
    });
  }

  // ─── Watch each block for async hydration ───────────────────────
  function watch(block, opts) {
    opts = opts || {};
    if (opts.pills) injectPills(block);
    wireArrows(block);

    var mo = new MutationObserver(function () {
      if (opts.pills) injectPills(block);
      wireArrows(block);
    });
    mo.observe(block, { childList: true, subtree: true });
  }

  function init() {
    markCurrent();
    document.querySelectorAll('.product-recommendations').forEach(function (b) {
      watch(b, { pills: false });
    });
    document.querySelectorAll('.recently-viewed-products').forEach(function (b) {
      watch(b, { pills: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
